import Amenity from ".";

export default class CommunityAmenity extends Amenity {

    icon = null;

    constructor(data) {
        super(data)

        this.icon = data?.icon ?? this.icon;
    }

    get types() {
        switch(this.group) {
            case 'standard' :
                return [
                    'Activity/ArtStudio',
                    'AmenityCenter',
                    'Amphitheater',
                    'Ballroom',
                    'Baseball',
                    'Basketball',
                    'BBQAreas',
                    'Beach',
                    'Billiards',
                    'BocceBallCourt',
                    'Cabana',
                    'CardRooms',
                    'Clubhouse',
                    'CommunityCenter',
                    'ConferenceRoom/Hall',
                    'ConservationArea',
                    'Cornhole',
                    'CoworkingSpaces',
                    'DiscGolf',
                    'DogGroomingRoom',
                    'DogPark',
                    'EventCenter',
                    'EventLawn',
                    'FirePit',
                    'Fishing',
                    'FitnessCenter',
                    'GameRoom',
                    'Garden',
                    'GolfCartPath/Access',
                    'GolfCourse',
                    'GolfSimulator', 
                    'Greenbelt',
                    'GuardedGate',
                    'HammockPark',
                    'HeatedOutdoorPool/Spa',
                    'HorseshoePit',
                    'HotTub',
                    'IndoorPool',
                    'Lake',
                    'LapPool',
                    'Marina',
                    'MountainViews',
                    'OceanView',
                    'OutdoorFireplace',
                    'OutdoorPatioWithFirepit',
                    'OutdoorPool',
                    'OutdoorRecreation',
                    'Park',
                    'Pavillion/Ramada',
                    'Pickleball',
                    'PicnicArea',
                    'Playground',
                    'PlayLawn',
                    'Pond',
                    'Pool',
                    'PuttingGreen',
                    'Sauna',
                    'Shuffleboard',
                    'Soccer',
                    'SplashPad',
                    'SportsCourts',
                    'SportsFields',
                    'Tennis',
                    'TotLot',
                    'Trails',
                    'Views',
                    'Volleyball',
                    'WaterfrontLots',
                    'WaterfrontViews',
                    'Waterpark',
                    'WoodedAreas',
                    'YogaStudio',
                    'Ziplining'
                ]
            case 'open' :
                return [
                    'CommunityServices',
                    'Education',
                    'HealthAndFitness',
                    'LocalAreaAmenities',
                    'SocialActivities'
                ]
        } 
    }
}